import React, { useState, useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

import sfondo from '../asset/servizi/sfondo.jpg';
import CardSlider from './components/cardslider';

gsap.registerPlugin(ScrollTrigger);

export default function Servizi() {
    const [isMobile, setIsMobile] = useState(false);
    const container = useRef();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useGSAP(() => {
        gsap.from('.servizi-wrapper', {
            scrollTrigger: {
                trigger: '.servizi-wrapper',
                start: 'top 85%',
                toggleActions: 'play none none none',
            },
            opacity: 0,
            scale: 0.95,
            y: 100,
            duration: 1.2,
            ease: 'power3.out',
        });

        gsap.from('.servizi-title', {
            scrollTrigger: {
                trigger: '.servizi-title',
                start: 'top 90%',
                toggleActions: 'play none none none',
            },
            opacity: 0,
            y: 40,
            duration: 1,
            delay: 0.2,
            ease: 'power2.out',
        });

        gsap.from('.servizi-subtitle', {
            scrollTrigger: {
                trigger: '.servizi-subtitle',
                start: 'top 90%',
                toggleActions: 'play none none none',
            },
            opacity: 0,
            y: 30,
            duration: 0.8,
            delay: 0.3,
            ease: 'power2.out',
        });

        gsap.from('.card-slider', {
            scrollTrigger: {
                trigger: '.card-slider',
                start: 'top 90%',
                toggleActions: 'play none none none',
            },
            opacity: 0,
            y: 50,
            duration: 1,
            delay: 0.5,
            ease: 'power3.out',
        });
    }, { scope: container });

    return (
        <section id='servizi' ref={container}>
            <div className="flex justify-center lg:pl-8 lg:pr-8 lg:pt-0 pt-4 pr-4 pl-4">
                <div
                    className="servizi-wrapper relative w-full p-4 pt-8 pb-8 h-[700px] flex justify-center rounded-3xl overflow-hidden shadow-2xl"
                    style={{
                        backgroundImage: `url(${sfondo})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                >
                    {/* Overlay scuro */}
                    <div className="absolute inset-0 bg-black/40 z-0"></div>

                    {/* Contenuto sopra lo sfondo */}
                    <div className="relative z-10 text-white text-center pt-5">
                        <h1 className='servizi-title text-white lg:text-6xl text-5xl font-bold'>
                            I nostri servizi
                        </h1>
                        {isMobile && (
                            <h2 className='servizi-subtitle text-white text-xl font-thin mt-5 pb-10'>
                                Scorri per scoprire i nostri servizi
                            </h2>
                        )}
                        <div className="card-slider">
                            <CardSlider />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
